module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-whiteboard-dev.web.app/assets/remoteEntry.js?t=1776224267664');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;